<template>
  <div class="user-card">
    <div class="name">
      <span v-if="user.last_name">
        {{ user.last_name }}
      </span>
      <span v-if="user.first_name">
        {{ user.first_name }}
      </span>

      <div class="updated-at" v-if="user.funnel_updated">
        {{ user.funnel_updated.seconds | moment("DD MMM  HH:SS") }}
      </div>
    </div>
    <div class="email">
      {{ user.email }}
    </div>
    <div class="controls">
      <span class="category">
        <b-icon-folder />
        <span v-if="user.category">
          {{ getCategory(user.category) }}
        </span>
        <span v-else> Без категорії </span>
      </span>
      <router-link
        :to="{ name: 'admin-user-single', params: { id: user.id } }"
        class="open-link"
        target="_blank"
        v-b-tooltip.hover
        title="Відкрити профіль"
      >
        <b-icon-eye />
      </router-link>
    </div>
    <div class="tags">
      <span
        v-for="t in user.tags"
        :key="t"
        v-b-tooltip.hover
        :title="getTagInfo(t).name"
        :style="{
          background:
            getTagInfo(t) && getTagInfo(t).color
              ? getTagInfo(t).color.hex
              : '#66',
        }"
      >
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["user"],
  computed: {
    ...mapGetters({
      categories: "categories",
      tags: "tags",
    }),
  },
  methods: {
    getCategory(id) {
      let found = this.categories.find((el) => {
        return Number(el.id) == Number(id);
      });
      return found.name;
    },
    getTagInfo(id) {
      let info = {
        name: "deleted_tag",
        color: {
          hex: "#f00",
        },
      };
      let found = this.tags.find((el) => {
        return Number(el.id) == Number(id);
      });
      if (found) {
        info = found;
      }

      return info;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-card {
  padding: 8px;
  background: #fff;
  margin-bottom: 8px;
  border-radius: 8px;
  margin-left: 4px;
  margin-right: 3px;
  box-shadow: 0px 1px 3px 0px rgba(#000, 0.2);
  transition: 0.3s;
  &:hover {
    box-shadow: 0px 2px 6px 0px rgba(#000, 0.2);
    transition: 0.3s;
  }
  cursor: pointer;
  .tags {
    span {
      display: inline-block;
      height: 10px;
      width: 10px;
      margin-right: 8px;
      border-radius: 50%;
      transition: 0.3s;
      &:hover {
        transform: scale(1.2);
        transition: 0.3s;
      }
    }
  }
  .controls {
    margin-top: 6px;
    padding-bottom: 3px;
    font-size: 14px;
    display: flex;
    margin-right: 3px;
    & > * {
      margin-right: 16px;
      color: #666;
    }
    a {
      text-decoration: none;
      &:hover {
        color: var(--primary-color);
      }
    }
    .category {
      span {
        font-size: 12px;
      }
    }
    .open-link {
      margin-left: auto;
      margin-right: 0;
    }
  }
  .name {
    color: var(--primary-color);
    font-weight: 600;
    font-size: 13px;
    display: flex;
    align-items: center;
    position: relative;
    span {
      margin-right: 4px;
      font-size: 14px;
    }
    .updated-at {
      margin-left: auto;
      font-size: 10px;
      font-weight: 300;
      color: #666;
      z-index: 2;
      background: #fff;
      white-space: nowrap;
      padding-right: 2px;
      position: absolute;
      right: 0;
      box-shadow: -6px 0px 4px 0px rgba(#fff, 0.6);
    }
  }
  .email {
    font-size: 10px;
    font-weight: 500;
    color: #666;
  }
}
</style>
